var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeoutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90193 2.88851C9.00635 2.14806 7.76652 2.14806 6.87102 2.88851L2.38259 6.59954C1.97331 6.93794 1.71977 7.47259 1.71977 8.05509V13.8423C1.71977 14.8985 2.51322 15.6665 3.38643 15.6665H5.0531V12.9563C5.0531 11.0771 6.49823 9.46542 8.38643 9.46542C10.2747 9.46542 11.7198 11.0771 11.7198 12.9563V15.6665H13.3864C14.2597 15.6665 15.0531 14.8985 15.0531 13.8423V8.05509C15.0531 7.47259 14.7996 6.93794 14.3903 6.59955L9.90193 2.88851ZM10.9639 1.60402L15.4523 5.31506C16.2609 5.98366 16.7198 6.99738 16.7198 8.05509V13.8423C16.7198 15.7215 15.2747 17.3332 13.3864 17.3332H11.7198C10.7993 17.3332 10.0531 16.587 10.0531 15.6665V12.9563C10.0531 11.9001 9.25968 11.1321 8.38643 11.1321C7.51318 11.1321 6.71977 11.9001 6.71977 12.9563V15.6665C6.71977 16.587 5.97358 17.3332 5.0531 17.3332H3.38643C1.49823 17.3332 0.0531006 15.7215 0.0531006 13.8423V8.05509C0.0531006 6.99738 0.511926 5.98366 1.32058 5.31506L5.80896 1.60402C7.32085 0.353998 9.45202 0.353998 10.9639 1.60402Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeoutline);
export default __webpack_public_path__ + "static/media/home.outline.10c5cb2c2beef811762cf60befd581cc.svg";
export { ForwardRef as ReactComponent };